import React from "react";

interface props {
  title: string;
  placeHolder: string;
  width?: string;
  hight?: string;
  px?: string;
}
function InputField(props: props) {
  return (
    <div className={`relative font-ar text-xl font-medium   ${props.px} pt-4 `}>
      <label htmlFor="dropdown-input" className="block text-gray-700 mb-2">
        {props.title}
      </label>
      <div className="relative ">
        <input
        placeholder={props.placeHolder}
          id="dropdown-input"
          type="text"
          readOnly
          disabled={true}
          className="w-full  bg-white   h-[61px]  px-3 py-2  rounded-2xl border-zinc-400 border "
        />
        <button
          type="button"
          disabled={true}
          className="absolute inset-y-0 left-0 px-4 py-2 "
        ></button>
      </div>
    </div>
  );
}

export default InputField;
